import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

const IGNORED_PAGE_SIZE = 10;

export function getQueryKey(queryKeyParams?: {
  directoryPath?: string;
  datasetId?: string;
  searchTerm?: string;
  extensions?: string[];
  showHiddenFiles?: boolean;
}) {
  if (queryKeyParams === undefined) {
    return ["directoryItemCount"];
  }

  return ["directoryItemCount", queryKeyParams];
}

export function useDirectoryItemCount(
  directoryPath: string,
  datasetId: string,
  resourceOwnerId?: string,
  searchTerm?: string,
  extensions?: string[],
  showHiddenFiles: boolean = false,
): UseQueryResult<number, Error> {
  const { files: fileService } = useDomainServices();

  return useQuery({
    queryKey: getQueryKey({
      directoryPath,
      datasetId,
      searchTerm,
      extensions,
      showHiddenFiles,
    }),
    queryFn: async ({ signal }) => {
      let itemCount = -1;

      if (searchTerm) {
        itemCount = await fileService.getFileCountForDirectory({
          path: directoryPath,
          datasetId,
          fileNameSearchTerm: searchTerm,
          extensions,
          showHiddenFiles,
          pageSize: IGNORED_PAGE_SIZE,
          options: {
            abortSignal: signal,
            resourceOwnerId,
          },
        });
      } else {
        itemCount = await fileService.getItemCountForDirectory({
          directoryPath,
          datasetId,
          extensions,
          showHiddenFiles,
          pageSize: IGNORED_PAGE_SIZE,
          options: {
            abortSignal: signal,
            resourceOwnerId,
          },
        });
      }

      return itemCount;
    },
    placeholderData: (previousData) => previousData,
  });
}
